export const forms = {
  login: [
    {
      id: 1,
      label: 'Código de socio',
      name: 'username',
      type: 'text'
    },
    {
      id: 2,
      label: 'Contraseña',
      name: 'password',
      type: 'password'
    }
  ]
}
